import './login.css';
import PasswordInput from '../../components/PasswordInput';
import { setAuthToken, login } from "../../services/api";
import { useState } from 'react';
import Input from '../../components/Input';
import { useNavigate } from 'react-router-dom';
import { useUI } from '../../UIContext';
import { handleErr } from '../../utils/functions';

function Login() {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [submitAttempt, setSubmitAttempt] = useState(false);
    const { setMessage } = useUI();

    const navigate = useNavigate();

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    async function authenticate(e) {
        function isAuthValid() {
            setSubmitAttempt(true);

            return !!email && !!password;
        }

        e.preventDefault();

        if (!isAuthValid())
            return;
        
        setLoading(true);

        const data = {
            email: email,
            password: password
        };

        await login('/user/authenticate', data, false, setMessage,
            (response) => {
                setAuthToken(response.data.token, navigate);
            },
            (err) => {
                handleErr(setMessage, `Falha ao acessar a conta: ${err}`);
            },
            () => {
                setLoading(false);
            }
        )
    }

    return (
        <div className='main-login'>
            <div id='login-header' className='container-login'>
                <div>
                    <h2>Bem-vindo de volta à Bertoli Tours - Admin!</h2>
                </div>
            </div>

            <div id="login-container" className='container-login'>
                <h2>Acesse sua conta</h2>

                <form id="user-login">
                    <Input
                        className='form-input'
                        type='text'
                        placeholder='E-mail'
                        value={email}
                        disabled={loading}
                        onChange={handleEmailChange}
                        onValidate={() => !!email}
                        warningMsg='O e-mail precisa ser preenchido.'
                        shouldValidate={submitAttempt}
                        maxLength={256}
                    />
                    <PasswordInput
                        className='form-input'
                        id='password'
                        value={password}
                        disabled={loading}
                        onChange={handlePasswordChange}
                        onValidate={() => !!password}
                        warningMsg='A palavra-passe precisa ser preenchida.'
                        shouldValidate={submitAttempt}
                        maxLength={40}
                    />

                    <input
                        id="confirm-button"
                        className={ loading ? 'blocked-button' : "blue-button" }
                        type="submit"
                        value={ loading ? 'Carregando...' : 'Entrar' }
                        disabled={loading}
                        onClick={authenticate}
                    />
                </form>
            </div>
        </div>
    );
}

export default Login;